import {
  DRIVER_PORTAL_LOCALE_STORAGE_KEY,
  isLanguage,
  languageFromTags,
  type Language,
} from '@repo/constants'
import { atomWithStorage } from 'jotai/utils'
import { store } from '.'

// Follow the OS/browser language until the user picks one explicitly. Only the
// base subtag matters — `es-MX` and `es-419` both resolve to `es`. Serving
// English to a Spanish device makes Chrome auto-translate the page, and its DOM
// mutations crash React with insertBefore errors (see the onboarding prod
// incident) — matching the device language avoids the translate prompt entirely.
const getBrowserLanguage = (): Language =>
  languageFromTags(navigator.languages?.length ? navigator.languages : [navigator.language])

// `null` means "no explicit choice yet", which is what keeps the browser
// language in play. Storing the detected value instead would turn "follow the
// OS" into a one-time snapshot. `getOnInit` keeps `getLocale()` synchronous so
// it can seed i18next's `lng` in __root.tsx.
const localeAtom = atomWithStorage<Language | null>(
  DRIVER_PORTAL_LOCALE_STORAGE_KEY,
  null,
  undefined,
  {
    getOnInit: true,
  },
)

// localStorage is untrusted — a stale or hand-edited value must not become the
// active language.
export const getLocale = (): Language => {
  const stored = store.get(localeAtom)
  return isLanguage(stored) ? stored : getBrowserLanguage()
}

export const setLocale = (locale: Language) => store.set(localeAtom, locale)
